export default "__VITE_ASSET__DX967kNy__"